import {
  CONSULTANT_MISSION_STATUS,
  DEFAULT_LANG,
  ED_STATUS_LABEL,
  PROFILE_ID_DEFAULT,
} from "constants/constants";
import { extractValue, handleSyntecCoefficientId, safeValue } from "./helper";
import { ENTITY } from "constants/info-header";

export const updateUserValues = (selectedDybPerson, setValue) => {
  setValue("email", selectedDybPerson?.email);
  setValue("personal_email", selectedDybPerson?.email);
  setValue("first_name", selectedDybPerson?.firstname);
  setValue("last_name", selectedDybPerson?.lastname);
  setValue("phone_number", selectedDybPerson?.phone);
};

export const getFilteredList = ({ list, value }) =>
  list?.filter((elm) => elm.value !== value);

export const formatCreatedData = (
  data,
  { contractualStatusList = [], flattedsyntecCoefList = [] } = {}
) => {
  const visa = !!data?.visa_type;

  const user = {
    email: data.email,
    enabled: data?.enabled,
    role: data?.role || [],
    user_language: DEFAULT_LANG.FR,
    picture_file_id: safeValue(data.picture_file_id),
  };

  const person = {
    arrival_date: data.arrival_date,
    comment: safeValue(data.comment, ""),
    dav_function: PROFILE_ID_DEFAULT.CONSULTANT,
    first_name: data.first_name,
    gender: data.gender,
    godfather_id: safeValue(data.godfather_id),
    last_name: data.last_name,
    phone_number: data.phone_number,
    profile_id: PROFILE_ID_DEFAULT.CONSULTANT,
    recruitment_mode_id: extractValue(data.recruitment_mode_id),
    referer_external: safeValue(data.referer_external),
    referer_internal_id: extractValue(data.referer_internal_id) || null,
    school: data.school,
    school_level: data.school_level,
    site_language: DEFAULT_LANG.FR,
  };

  const consultant = {
    contractual_status_id: data.contractual_status_id,
    address: data.address,
    birth_place: data.birth_place,
    birthday: data.birthday,
    cegid_id: safeValue(data.cegid_id),
    children_information: Number(data.children_information) || 0,
    comment_company_rtt: safeValue(data.comment_company_rtt),
    dashboard_comment: safeValue(data.dashboard_comment),
    degree: safeValue(data.degree),
    degree_year: safeValue(data.degree_year),
    dyb_showcase_id: extractValue(data.dyb_showcase_id, Number),
    experience_comment: safeValue(data.experience_comment),
    extranet_account: data.extranet_account ?? false,
    gp_id: extractValue(data.gp_id),
    nationality_id: extractValue(data.nationality),
    personal_email: data.personal_email,
    recruitment_experience: Number(data.recruitment_experience),
    visa,
    visa_expiration_date: visa ? safeValue(data.visa_expiration_date) : null,
    visa_number: visa ? safeValue(data.visa_number) : null,
    visa_status: visa ? safeValue(data.visa_status) : "",
    visa_type: visa ? safeValue(data.visa_type) : null,
  };

  const coefficient = {
    start_date: data.start_date,
    syntec_coef_position: handleSyntecCoefficientId({
      data: {
        contractual_status_id: data.contractual_status_id,
        syntec_coef_position_staff: data.syntec_coef_position,
      },
      contractualStatusList: contractualStatusList,
      flattedsyntecCoefList: flattedsyntecCoefList,
      entity: ENTITY.CONSULTANT,
    }),
  };

  const worker = {
    sigle: "AZF",
    status: "status_one",
  };

  const salary = {
    comment: safeValue(data.salary_comment),
    currency_id: extractValue(data.currency_id),
    establishment_date: data.salary_establishment_date || data.start_date,
    establishment_date_end: safeValue(data.salary_establishment_date_end),
    value: Number(data.salary) || Number(data.salary_value),
  };

  const contract = {
    branch_id: extractValue(data.branch_id),
    contract_type: data.contract_type,
    end_date: safeValue(data.end_date),
    leaving_reason_id: extractValue(data.leaving_reason_id) || null,
    start_date: data.start_date,
  };

  const history_manager = {
    manager_id: extractValue(data.manager_id),
    establishment_date:
      data.history_manager_establishment_date || data.start_date,
    establishment_date_end: safeValue(
      data.history_manager_establishment_date_end
    ),
    branch_id: extractValue(data.branch_id),
  };

  // The job history line no longer carries a category (redmine 12940): it
  // follows from `domain_id`.
  const domain = {
    domain_id: extractValue(data.domain_id),
    establishment_date: data.domain_establishment_date || data.start_date,
    establishment_date_end: safeValue(data.domain_establishment_date_end),
    mission_id: safeValue(data.mission_id),
  };

  return {
    user,
    person,
    consultant,
    coefficient,
    worker,
    salary,
    contract,
    history_manager,
    domain,
  };
};

export const getConsultantMissionStatus = (status) => {
  switch (status) {
    case CONSULTANT_MISSION_STATUS.STATUS_ED:
      return CONSULTANT_MISSION_STATUS.ED;
    case CONSULTANT_MISSION_STATUS.STATUS_IC:
      return CONSULTANT_MISSION_STATUS.IC;
    case CONSULTANT_MISSION_STATUS.STATUS_OK:
      return CONSULTANT_MISSION_STATUS.OK;
    case CONSULTANT_MISSION_STATUS.STATUS_EMPTY:
      return CONSULTANT_MISSION_STATUS.EMPTY;
    case CONSULTANT_MISSION_STATUS.STATUS_OUT:
      return CONSULTANT_MISSION_STATUS.OUT;
    case CONSULTANT_MISSION_STATUS.STATUS_BACKUP:
      return CONSULTANT_MISSION_STATUS.BACKUP;
    case CONSULTANT_MISSION_STATUS.STATUS_ZERO:
      return CONSULTANT_MISSION_STATUS.STATUS_0;
    case CONSULTANT_MISSION_STATUS.STATUS_ONE:
      return CONSULTANT_MISSION_STATUS.STATUS_1;
    case CONSULTANT_MISSION_STATUS.STATUS_FDM:
      return CONSULTANT_MISSION_STATUS.FDM;
    default:
      return status;
  }
};

export const getMissionStatusColor = (status) => {
  switch (status) {
    case CONSULTANT_MISSION_STATUS.ED:
    case CONSULTANT_MISSION_STATUS.STATUS_ED:
      return "light-violet";
    case CONSULTANT_MISSION_STATUS.IC:
    case CONSULTANT_MISSION_STATUS.STATUS_IC:
      return "light-red";
    case CONSULTANT_MISSION_STATUS.OK:
    case CONSULTANT_MISSION_STATUS.STATUS_OK:
      return "green-blue-1";
    case CONSULTANT_MISSION_STATUS.OUT:
    case CONSULTANT_MISSION_STATUS.STATUS_OUT:
    case CONSULTANT_MISSION_STATUS.STATUS_BACKUP:
    case CONSULTANT_MISSION_STATUS.STATUS_ZERO:
    case CONSULTANT_MISSION_STATUS.STATUS_0:
      return "selago";
    case CONSULTANT_MISSION_STATUS.STATUS_ONE:
    case CONSULTANT_MISSION_STATUS.STATUS_1:
      return "light-lime-green";
    case CONSULTANT_MISSION_STATUS.CL:
    case CONSULTANT_MISSION_STATUS.STATUS_CL:
      return "light-peach";
    case CONSULTANT_MISSION_STATUS.FDM:
    case CONSULTANT_MISSION_STATUS.STATUS_FDM:
      return "light-yellow";
    case CONSULTANT_MISSION_STATUS.HD:
      return "amnesia";
    case CONSULTANT_MISSION_STATUS.EMPTY:
    case CONSULTANT_MISSION_STATUS.STATUS_EMPTY:
      return "light-purple";
    default:
      return "";
  }
};

export const getMissionStatusLabel = (status) => {
  switch (status) {
    case CONSULTANT_MISSION_STATUS.ED:
    case CONSULTANT_MISSION_STATUS.STATUS_ED:
      return "ED";
    case CONSULTANT_MISSION_STATUS.IC:
    case CONSULTANT_MISSION_STATUS.STATUS_IC:
      return "IC";
    case CONSULTANT_MISSION_STATUS.OK:
    case CONSULTANT_MISSION_STATUS.STATUS_OK:
      return "OK";
    case CONSULTANT_MISSION_STATUS.OUT:
    case CONSULTANT_MISSION_STATUS.STATUS_OUT:
      return "OUT";
    case CONSULTANT_MISSION_STATUS.STATUS_ONE:
    case CONSULTANT_MISSION_STATUS.STATUS_1:
      return "1";
    case CONSULTANT_MISSION_STATUS.CL:
    case CONSULTANT_MISSION_STATUS.STATUS_CL:
      return "CL";
    case CONSULTANT_MISSION_STATUS.FDM:
    case CONSULTANT_MISSION_STATUS.STATUS_FDM:
      return "FDM";
    case CONSULTANT_MISSION_STATUS.STATUS_BACKUP:
      return "Backup";
    case CONSULTANT_MISSION_STATUS.STATUS_ZERO:
      return "0";
    case CONSULTANT_MISSION_STATUS.STATUS_EMPTY:
      return "Empty";
    default:
      return status;
  }
};

// Tags show "ENTREE" for ED, while mission titles keep the "ED" code.
export const getMissionStatusTagLabel = (status) =>
  status === CONSULTANT_MISSION_STATUS.ED ||
  status === CONSULTANT_MISSION_STATUS.STATUS_ED
    ? ED_STATUS_LABEL
    : getMissionStatusLabel(status);
